export const CHECKOUT_URL =
  'https://metabolismorestartpro.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/agpmeBPVNzgJYQjPWErxWU/ChatGPT_Image_22_ago_2026,_22_41_16.png'

export const CTA_LABEL = 'Quiero empezar mi reset'

/* ---------- Hero ---------- */

export const microbeneficios: string[] = [
  'Alimentación organizada',
  'Manejo de antojos',
  'Horarios con estructura',
  'Pasos claros para hoy',
]

/* ---------- Sección de dolor ---------- */

export const flujoDolor: string[] = [
  'Empiezas con motivación',
  'Improvisas',
  'Vuelven los antojos',
  'Pierdes la estructura',
  'Empiezas de nuevo',
]

export const dolores: string[] = [
  'Improvisar qué comer cada día',
  'Llegar con demasiada hambre',
  'Horarios de comida y descanso desordenados',
  'Planes difíciles de mantener',
]

/* ---------- Pilares del Reset (mecanismo) ---------- */

export interface Pilar {
  numero: string
  titulo: string
  descripcion: string
  icono: 'alimentacion' | 'horarios' | 'antojos' | 'continuidad'
}

export const pilares: Pilar[] = [
  {
    numero: '01',
    titulo: 'Alimentación',
    descripcion:
      'Estructura tus comidas y combinaciones sin contar calorías.',
    icono: 'alimentacion',
  },
  {
    numero: '02',
    titulo: 'Horarios',
    descripcion: 'Organiza cuándo comes y descansas para ser más consistente.',
    icono: 'horarios',
  },
  {
    numero: '03',
    titulo: 'Antojos y hábitos',
    descripcion:
      'Detecta lo que te lleva a comer por impulso y cómo manejarlo.',
    icono: 'antojos',
  },
  {
    numero: '04',
    titulo: 'Continuidad',
    descripcion: 'Una estructura simple para saber qué hacer después.',
    icono: 'continuidad',
  },
]

/* ---------- Los 6 tomos ---------- */

export interface Tomo {
  numero: string
  titulo: string
  beneficio: string
  resumen: string
  portada: string
}

export const tomos: Tomo[] = [
  {
    numero: 'Tomo 1',
    titulo: 'Código de la Desinflamación',
    beneficio: 'Empieza por la base',
    resumen:
      'Detecta los hábitos que más te desordenan y arranca con una estructura simple.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/285f81ba-0e48-4c84-829b-3272bd589fd6.jpg',
  },
  {
    numero: 'Tomo 2',
    titulo: 'Blindaje de Glucosa',
    beneficio: 'Come con más estrategia',
    resumen:
      'Combinaciones sencillas para comer mejor sin restricciones extremas.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/32e814fb-28e2-45fa-b552-0819af374287.jpg',
  },
  {
    numero: 'Tomo 3',
    titulo: 'Switch Circadiano',
    beneficio: 'Ordena tus horarios',
    resumen: 'Comidas, descanso y rutina con más consistencia durante el día.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/25cf3d93-802c-49e0-97ac-7c1bf839b896.jpg',
  },
  {
    numero: 'Tomo 4',
    titulo: 'Detox Celular y Linfático',
    beneficio: 'Hábitos que suman',
    resumen:
      'Hidratación, movimiento y hábitos cotidianos dentro de una rutina práctica.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/d23f8eb9-7bfb-4214-a442-5c3fb1cf522d.jpg',
  },
  {
    numero: 'Tomo 5',
    titulo: 'Despensa Inteligente',
    beneficio: 'Haz más fácil comer mejor',
    resumen: 'Listas y combinaciones para dejar de improvisar cada comida.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/fca8fd9a-c1a2-4043-aa48-53ed3bf85d3c.jpg',
  },
  {
    numero: 'Tomo 6',
    titulo: 'Plan Maestro 30 Días',
    beneficio: 'No vuelvas al punto de partida',
    resumen: 'Menús, recetas y estructura para continuar después del reset.',
    portada:
      'https://cdn.magicpatterns.com/patterns/generated-images/c0b71e18-a5f8-46b7-bdd7-02dafbd9f5f7.jpg',
  },
]

/* ---------- Cómo empiezas ---------- */

export interface Paso {
  numero: string
  titulo: string
  descripcion: string
}

export const pasos: Paso[] = [
  {
    numero: '01',
    titulo: 'Identifica',
    descripcion:
      'Tu punto de partida: qué hábitos y horarios generan más desorden.',
  },
  {
    numero: '02',
    titulo: 'Aplica',
    descripcion:
      'Sigue el reset paso a paso, sin intentar cambiar todo al mismo tiempo.',
  },
  {
    numero: '03',
    titulo: 'Continúa',
    descripcion:
      'Usa el Plan Maestro para mantener la estructura y no volver a improvisar.',
  },
]

/* ---------- Recursos extra (bonus) ---------- */

export interface Bonus {
  numero: string
  titulo: string
  frase: string
}

export const bonuses: Bonus[] = [
  {
    numero: '1',
    titulo: 'Protocolo SOS 24 Horas',
    frase: 'Para los días en que la rutina se desordena y necesitas volver.',
  },
  {
    numero: '2',
    titulo: 'Comer Fuera Sin Sabotaje',
    frase: 'Restaurantes, reuniones, viajes y fines de semana.',
  },
  {
    numero: '3',
    titulo: 'Metabolismo en Movimiento',
    frase: 'Rutinas breves, sin sesiones largas.',
  },
  {
    numero: '4',
    titulo: 'Biohacking de Cocina',
    frase: 'Prepara tus comidas con menos decisiones diarias.',
  },
  {
    numero: '5',
    titulo: 'Despensa Inteligente: Checklist',
    frase: 'Compra con criterio y revisa lo que llevas a casa.',
  },
]

/* ---------- Situaciones que el método busca resolver ---------- */

export const situaciones: string[] = [
  'Dejar de decidir todo sobre la marcha: con una estructura, organizar las comidas es mucho más simple.',
  'Tener una guía que puedas adaptar a tu rutina, en lugar de reglas imposibles.',
  'Saber qué hacer después, para no volver al mismo desorden a los pocos días.',
]

/* ---------- Esto es para ti si... ---------- */

export const paraTi: string[] = [
  'Empiezas planes y los abandonas',
  'Quieres comer mejor sin restricciones extremas',
  'Necesitas organizar comidas y horarios',
  'Tienes mucha información y ningún plan',
  'Buscas una estructura adaptable',
  'Quieres dejar de improvisar',
]

/* ---------- Qué incluye la oferta ---------- */

export const incluye: string[] = [
  '6 tomos digitales',
  '5 recursos extra',
  'Plan inicial paso a paso',
  'Plan Maestro 30 días',
  'Menús y recetas',
  'Acceso de por vida',
]

/* ---------- FAQ ---------- */

export interface FaqItem {
  pregunta: string
  respuesta: string
}

export const faqs: FaqItem[] = [
  {
    pregunta: '¿Es una dieta keto?',
    respuesta:
      'No. Metabolismo Reset no está diseñado como una dieta keto ni como un régimen extremo. Es una guía práctica para organizar comidas, horarios y hábitos utilizando opciones flexibles que puedas adaptar a tu rutina.',
  },
  {
    pregunta: '¿Tengo que leer todo antes de empezar?',
    respuesta:
      'No. El sistema está organizado para que puedas comenzar por el primer paso y avanzar progresivamente. No necesitas estudiar todo el material antes de aplicarlo.',
  },
  {
    pregunta: '¿Qué recibo exactamente?',
    respuesta:
      'Recibes acceso inmediato al protocolo Metabolismo Reset, sus 6 tomos digitales, el Plan Maestro de 30 días y los 5 recursos adicionales incluidos en la oferta.',
  },
  {
    pregunta: '¿Tengo que comprar suplementos?',
    respuesta:
      'No. El método está diseñado alrededor de alimentación, organización, descanso y hábitos cotidianos. No necesitas comprar suplementos específicos para comenzar.',
  },
  {
    pregunta: '¿Es un producto físico?',
    respuesta:
      'No. Todo el contenido es 100% digital y puedes acceder desde tu teléfono, tablet o computadora.',
  },
  {
    pregunta: '¿Es un pago único?',
    respuesta:
      'Sí. Realizas un solo pago de USD 12.99 y no existen mensualidades ni suscripciones.',
  },
  {
    pregunta: '¿Cuánto tiempo tengo acceso?',
    respuesta: 'El acceso al contenido adquirido es de por vida.',
  },
  {
    pregunta: '¿Funciona si tengo hipotiroidismo u otra condición?',
    respuesta:
      'Metabolismo Reset es una guía general de alimentación y hábitos y no sustituye indicaciones médicas. Si tienes una condición diagnosticada, tomas medicación o sigues un tratamiento específico, consulta con tu profesional de salud antes de realizar cambios importantes en tu alimentación o rutina.',
  },
  {
    pregunta: '¿Qué pasa si el contenido no es para mí?',
    respuesta:
      'Tienes 7 días para revisar el contenido. Si no es para ti, puedes solicitar la devolución según las condiciones de garantía.',
  },
]
